/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
export const ERF_P = 0.3275911;
export const ERF_A1 = 0.254829592;
export const ERF_A2 = -0.284496736;
export const ERF_A3 = 1.421413741;
export const ERF_A4 = -1.453152027;
export const ERF_A5 = 1.061405429;
//# sourceMappingURL=erf_util.js.map